export default __webpack_public_path__ + "static/media/4700@3x.3916bad1.png";